import type { ReactNode } from 'react';

type ProgressDisplayProps = {
  eventsStarted: number;
  maxEvents: number;
};

/**
 * The progress display for the betslip.
 *
 * @param root0 input object
 * @param root0.eventsStarted the number of events that the user has selected
 * @param root0.maxEvents the maximum number of events
 * @returns The progress of the selected events in the betslip.
 */
export default function BetslipProgressDisplay({ eventsStarted, maxEvents }: ProgressDisplayProps): ReactNode {
  return (
    <div className="whitespace-nowrap">
      {eventsStarted} av {maxEvents}
    </div>
  );
}
